"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDispatcher = void 0;
class EventDispatcher {
    listeners = [];
    hasEventListener(type, listenerFunction, scope) {
        return this.listeners.some(listener => listener.type === type && listener.listenerFunction === listenerFunction && listener.scope === scope);
    }
    addEventListener(type, listenerFunction, scope) {
        if (this.hasEventListener(type, listenerFunction, scope)) {
            console.warn(`Listener already added for event type: ${type}`);
            return;
        }
        this.listeners.push({ type, listenerFunction, scope });
    }
    removeEventListener(type, listenerFunction, scope) {
        this.listeners = this.listeners.filter(listener => listener.type !== type || listener.listenerFunction !== listenerFunction || listener.scope !== scope);
    }
    removeAllEventListeners() {
        this.listeners = [];
    }
    dispatchEvent(evt) {
        const matchedListeners = this.listeners.filter(listener => listener.type === evt.getType());
        for (const listener of matchedListeners) {
            listener.listenerFunction.call(listener.scope, evt.getParams());
        }
    }
}
exports.EventDispatcher = EventDispatcher;
